(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
		popupSliderInit(true);

		const mainProductSection = document.querySelector(".main-product-section");
		if (mainProductSection?.dataset?.mainProductDifferentGallery === "true") {
			window.__mainProductDifferentGallery = true;

			subSliderInit(true, ".js-media-mobile-list", ".js-media-mobile-sublist");
			sliderInit(true, ".js-media-mobile-list", ".js-media-mobile-sublist");
		}
	}

	// NEVERONMONDAY
	// In de theme editor wordt een sectie bij elke instellingswijziging opnieuw ingeladen.
	// De originele code her-initialiseerde Swiper daarna niet meer (isSwiperInit bleef true
	// en de tweede listener stond op { once: true }), waardoor de productgalerij leeg bleef
	// in de editor terwijl ze live wel werkte. We her-initialiseren nu bij elke section:load
	// die effectief slider-markup bevat.
	function handleSectionLoad(event) {
		const target = event && event.target;
		const hasSliders =
			!target ||
			typeof target.querySelector !== "function" ||
			!!target.querySelector(".swiper, .product__media-wrapper, [data-main-product-section]");

		if (!hasSliders) return;

		// laat de browser eerst de nieuwe markup plaatsen voor we Swiper opbouwen
		window.requestAnimationFrame(function () {
			try {
				swiperInit();
			} catch (e) {
				console.warn("Swiper re-init na section:load mislukt", e);
			}
		});
	}

	document.addEventListener("shopify:section:load", handleSectionLoad);

	// This file is loaded from both the main-product.liquid and featured-product.liquid files
	// and is called twice. To avoid the variable being initialized and the slider being
	// instantiated multiple times, need to implement a isSwiperInit variable to prevent double initialization
	if (!window?.isSwiperInit) {
		swiperInit();
	}

	window.isSwiperInit = true;
})();
